export class DistrictDTO {
  public districtCode: string;
  public description: string;
  public status: string;
  public province: string;
  public user: string;
  public url: string;


  constructor(districtCode: string, description: string, status: string, province: string, user: string, url: string) {
    this.districtCode = districtCode;
    this.description = description;
    this.status = status;
    this.province = province;
    this.user = user;
    this.url = url;
  }
}
